import {
  SET_SEARCH_RESULTS,
  SET_SEARCH_PAGE_LIMIT,
  SET_PAGINATION_PAGE_NUMBER,
  SET_SEARCH_PAGINATION_MODE,
  SET_SEARCH_QUERY,
  SET_SEARCH_PHRASE,
  SET_CURRENT_SEARCH_PHRASE,
  SET_SEARCH_TYPE,
  SET_CURRENT_SEARCH_TYPE,
  SET_SEARCH_RESPONSE,
  SET_SEARCH_TYPE_DISPLAY_NAME,
  SET_SEARCH_TYPE_CLASSES,
  SET_SEARCH_HELPER_VISIBLE
} from 'redux/actions/types'
import produce from 'immer'
import { Reducer } from 'redux'
import { SearchType } from 'types/Search';

export interface SearchState {
  pageLimit: number|null;
  pageNumber: number;
  paginationMode: 'paged' | 'all';
  query: any;
  results: any;
  searchPhrase:string;
  currentSearchPhrase:string;
  searchType: SearchType;
  currentSearchType:SearchType;
  displayName:string;
  searchTypeClasses:string;
  response:any;
  searchHelperVisible: boolean;
}

const initialState: SearchState = {
  pageLimit: null,
  pageNumber: 1,
  paginationMode: 'paged',
  query: {},
  results: null,
  searchPhrase: '',
  currentSearchPhrase: '',
  searchType: 'qa',
  currentSearchType: 'qa',
  displayName: '',
  searchTypeClasses: '',
  response: null,
  searchHelperVisible: false
}

const search:Reducer<SearchState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_RESULTS:
      return produce(state, draft => {
        draft.results = action.results
      })
    case SET_SEARCH_PAGE_LIMIT:
      return produce(state, draft => {
        draft.pageLimit = action.pageLimit
      })
    case SET_PAGINATION_PAGE_NUMBER:
      return produce(state, draft => {
        draft.pageNumber = action.pageNumber
      })
    case SET_SEARCH_PAGINATION_MODE:
      return produce(state, draft => {
        draft.paginationMode = action.paginationMode
      })
    case SET_SEARCH_QUERY:
      return produce(state, draft => {
        draft.query = action.query
      })
    case SET_SEARCH_PHRASE:
      return produce(state, draft => {
        draft.searchPhrase = action.searchPhrase
      })
    case SET_CURRENT_SEARCH_PHRASE:
      return produce(state, draft => {
        draft.currentSearchPhrase = action.searchPhrase
      })
    case SET_SEARCH_TYPE:
      return produce(state, draft => {
        draft.searchType = action.searchType
      })
    case SET_CURRENT_SEARCH_TYPE:
      return produce(state, draft => {
        draft.currentSearchType = action.searchType
      })
    case SET_SEARCH_RESPONSE:
      return produce(state, draft => {
        draft.response = action.response
      })
    case SET_SEARCH_TYPE_DISPLAY_NAME:
      return produce(state, draft => {
        draft.displayName = action.displayName
      })
    case SET_SEARCH_TYPE_CLASSES:
      return produce(state, draft => {
        draft.searchTypeClasses = action.searchTypeClasses
      })
    case SET_SEARCH_HELPER_VISIBLE:
      return produce(state, draft => {
        draft.searchHelperVisible = action.searchHelperVisible
      })
    default:
      return state
  }
}

export default search
